class ApplicationView extends ViewBasic {
    constructor(options) {
        super(options);
    }

    init(){
        this.$revealable = this.$('.revealable');
        this.$row = this.$('.overflow-container');
        this.$rowBaseHeight = this.$row.height();

        this.$statusSelect = this.$('#application-status');
        this.$statusForm = this.$('.form-status');
        this.$statusData = this.$('.form-status').attr('data-status');


        this.$deleteBtn = this.$('.delete');
        this.$deleteForm = this.$('.form-delete');

        this.isComingFromMobile = false;

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': this.$statusForm.attr('data-token')
            }
        });

        let $options = this.$('#application-status option');
        let scope = this;
        $options.each(function (index, element) {
            $(element).removeAttr('data-default');

            if (this.value === scope.$statusData) {
                $(element).attr('data-default', '');
            }
        });

        this.skin = new Me.skin(this.$('.application-status-dropdown'));

        this.addEvents();
    }

    addEvents() {
        Me.dispatch.subscribe('breakpointChanged', (e, params) => this.handleBreakpoints(e, params));
        this.$('.toggler').on('click', (e) => this.changeApplicationState(e));
        this.$deleteBtn.on('click', (e) => this.deleteApplication(e));
        this.$statusSelect.on('change', (e) => this.updateStatus(e));
    }

    removeEvents() {
        Me.dispatch.unsubscribe('breakpointChanged', (e, params) => this.handleBreakpoints(e, params));
        this.$('.toggler').off('click', (e) => this.changeApplicationState(e));
        this.$deleteBtn.off('click', (e) => this.deleteApplication(e));
        this.$statusSelect.off('change', (e) => this.updateStatus(e));
    }

    changeApplicationState(e) {

        this.$row.parent('.row').toggleClass('expended');

        this.resizeApplicationRow(e);
    }

    resizeApplicationRow(e){
        this.$extraInfosHeight = this.$('.extra-infos').outerHeight();

        if(this.$row.parent('.row').hasClass('expended')){
            let biggestHeight = 0;
            let heightArray = new Array();

            this.$revealable.each(function () {
                heightArray.push($(this).outerHeight());
            });

            biggestHeight = Math.max(...heightArray);

            this.$row.height(this.$rowBaseHeight + biggestHeight + this.$extraInfosHeight);
        }
        else{
            this.$row.height(this.$rowBaseHeight);
        }
    }

    deleteApplication(e){
        let scope = this;
        e.preventDefault();

        setTimeout(function(){
            Me.dispatch.emit('Application.getID', this, {applicationId: scope.$deleteBtn.attr('data-id')})
        },0);
    }

    updateStatus(e) {
        // Update status
        $.ajax({
            type: this.$statusForm.attr('method'),
            url: this.$statusForm.attr('action'),
            data: {
                id : this.$statusForm.attr('data-id'),
                status : $(e.currentTarget).val()
            }
        });
    }

    handleBreakpoints(e, params) {
        if(params.breakpoint == '767-'){
            if(this.$row.parent('.row').hasClass('expended')){
                this.$row.parent('.row').removeClass('expended');
            }
            this.$row.addClass('mobile-height');
            this.isComingFromMobile = true;
        }
        else{
            if(this.$row.hasClass('mobile-height')){
                this.$row.removeClass('mobile-height');

                if(this.isComingFromMobile){
                    this.$row.height(this.$rowBaseHeight);
                }
            }
            else{
                this.resizeApplicationRow();
            }
            this.isComingFromMobile = false;
        }
    }
}

